module.exports = __webpack_public_path__ + "static/dynamo-d2ec9ad2f735f7353c05648661efec36.jpg";